<template>
    <div class="yingbi_item" v-for="item in items" :key="item.id">
      <div class="yingbi_item_left">
        <div class="yingbi_item_left_name">{{ item.sourceIntro }}</div>
        <div class="yingbi_item_left_date">{{ formatDate(item.createdAt) }}</div>
      </div>
      <div class="yingbi_item_right">
        <span v-if="item.coinCount > 0">+{{ item.coinCount }}</span>
        <span v-else>{{ item.coinCount }}</span>
      </div>
    </div>
  </template>
  
  <script setup>
  import { defineProps } from 'vue';
  
  defineProps({
    items: {
      type: Array,
      required: true
    }
  });

const formatDate = (timestamp) => {
  try {
    // 1. 输入验证
    if (!timestamp) {
      return '无效日期';
    }
    
    // 2. 处理不同类型的输入
    let date;
    
    if (timestamp instanceof Date) {
      date = timestamp;
    } else if (typeof timestamp === 'string') {
      // 处理常见格式：
      // - "2025-11-16 11:34:53"
      // - "2025-11-16T11:34:53"
      // - "2025/11/16 11:34:53"
      const normalizedTimestamp = timestamp
        .replace(' ', 'T')
        .replace(/\//g, '-');
      date = new Date(normalizedTimestamp);
    } else if (typeof timestamp === 'number') {
      // 处理时间戳（毫秒）
      date = new Date(timestamp);
    } else {
      return '无效日期';
    }
    
    // 3. 验证日期有效性
    if (!date || isNaN(date.getTime())) {
      return '无效日期';
    }
    
    // 4. 使用 toLocaleString 格式化
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'Asia/Shanghai' // 指定时区，避免时区问题
    };
    
    let formattedDate = date.toLocaleString('zh-CN', options);
    
    // 5. 处理不同浏览器的输出格式差异
    // 某些浏览器输出: "2025/11/16 11:34:53"
    // 某些浏览器输出: "2025年11月16日 11:34:53"
    
    // 如果已经是中文格式，直接返回
    if (formattedDate.includes('年')) {
      return formattedDate;
    }
    
    // 如果是斜杠格式，转换为中文格式
    // "2025/11/16 11:34:53" -> "2025年11月16日 11时34分53秒"
    const match = formattedDate.match(/(\d{4})[/-](\d{2})[/-](\d{2})\s+(\d{2}):(\d{2}):(\d{2})/);
    
    if (match) {
      const [, year, month, day, hour, minute, second] = match;
      return `${year}年${month}月${day}日 ${hour}时${minute}分${second}秒`;
    }
    
    // 6. 如果格式不匹配，回退到手动格式化
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    const second = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}年${month}月${day}日 ${hour}时${minute}分${second}秒`;
    
  } catch (error) {
    console.error('日期格式化错误:', error);
    return '日期格式错误';
  }
};



//   const formatDate = (timestamp) => {
//   const date = new Date(timestamp.replace(' ', 'T'));
//   const options = {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit'
//   };
//   const formattedDate = date.toLocaleString('zh-CN', options);
//   return formattedDate;
//   // return formattedDate.replace(/\//g, '年').replace(/月/g, '月').replace(/日/g, '日 ').replace(/:/g, '时') + '秒';
// };
  </script>
  
  <style scoped>
  /* 添加你的样式 */

  .yingbi_item{
    margin-bottom: 0.5rem;
    margin-left: 0.02rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }

  .yingbi_item_left{
    display: flex;
    flex-direction: column;
    justify-content: left;
    
  }

  .yingbi_item_left_name{
    font-size: 0.4rem;
    color: #000000;
    margin-top: 0.2rem;
    font-weight: bold;
   
    text-align: left;
  }

  .yingbi_item_left_date{
    font-size: 0.3rem;
    color: #848488;
    margin-top: 0.2rem;
    text-align: left;
  }

  .yingbi_item_right{
    font-size: 0.4rem;
    color: #000000;
    margin-top: 0.2rem;
    text-align: right;
    font-weight: bold;
  }
  </style>